module.exports = __webpack_public_path__ + "static/media/leader.57c024f0.png";